import {ActionTree} from "vuex";
import {UserRoleFilter, UserRoleItem, UserRolesState} from "@/store/user_management/roles/types";
import {RootState} from "@/store/types";
import axios from "axios";
import {directDownload} from "@/utils/download-helper";

export const actions: ActionTree<UserRolesState, RootState> = {
  getUserRoles: ({commit, dispatch},data:UserRoleFilter) => {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      axios({url: '/acapi/roles',params: data})
        .then(resp => {
          commit('setUserRoles', resp.data.roles);
          resolve(resp)
        })
        .catch(err => {
          // errorNotify(err);
          reject(err)
        })
        .finally(() => commit('setLoading', false))
    })
  },
  getUserRoleItem: async ({commit, dispatch},id?:number) => {
    commit('setLoading', true);
    try {
      let resp = await axios({url: `/acapi/roles/${id ?? 'current'}`})
      let userRoleItem = <UserRoleItem>resp.data;
      userRoleItem.id = id;
      commit('setUserRoleItem', userRoleItem);
      return userRoleItem
    } catch(err){
      throw err;
    } finally {
      commit('setLoading', false)
    }
  },
  saveUserRole: ({commit, dispatch}, data:UserRoleItem) => {
    commit('setLoading', true);
    // Тут такое не разбериха нужно было добавить header при изменении ролей
    axios.defaults.headers["Request-Change-Permissions"] = true;
    return new Promise((resolve, reject) => {
      data.system_pages?.filter(value => !value.allowed).map(value => value.allowed = false)
      axios({
        method: data.id ? 'put' : 'post',
        url: '/acapi/roles/' + (data.id ?? ''),
        data: data
      })
        .then((resp:any) => {
          console.log(resp.data);
          dispatch('getUserRoles');
          resolve(resp)
        })
        .catch((err:any) => {
          // errorNotify(err);
          reject(err)
        })
        .finally(() => {
          // соответственно я его удаляю
          delete axios.defaults.headers["Request-Change-Permissions"]
          commit('setLoading', false)
        })
    })
  },
  deleteUserRole: ({commit, dispatch}, data:UserRoleItem) => {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      axios({
        method: 'delete',
        url: `/acapi/roles/${data.id}`,
        data: data
      })
        .then((resp:any) => {
          dispatch('getUserRoles');
          resolve(resp)
        })
        .catch((err:any) => {
          reject(err)
        })
        .finally(() => commit('setLoading', false))
    })
  },
  exportUserRoles: ({commit, dispatch}, data: UserRoleFilter) => {
    return directDownload('/acapi/roles/export', data)
  }
}
